const actions = {
  SEARCH_CONTENTS_REQUEST: "CONTENT_LIST/SEARCH_CONTENTS_REQUEST",
  SEARCH_CONTENTS_SUCCESS: "CONTENT_LIST/SEARCH_CONTENTS_SUCCESS",
  SEARCH_CONTENTS_ERROR: "CONTENT_LIST/SEARCH_CONTENTS_ERROR",

  GET_CONTENTS_CSV_REQUEST: "CONTENT_LIST/GET_CONTENTS_CSV_REQUEST",
  GET_CONTENTS_CSV_SUCCESS: "CONTENT_LIST/GET_CONTENTS_CSV_SUCCESS",
  GET_CONTENTS_CSV_ERROR: "CONTENT_LIST/GET_CONTENTS_CSV_ERROR",

  searchContents: (payload) => ({
    type: actions.SEARCH_CONTENTS_REQUEST,
    payload,
  }),

  getContentsCsv: (payload) => ({
    type: actions.GET_CONTENTS_CSV_REQUEST,
    payload,
  }),
};

export default actions;
